import React from 'react';
import { useAISalesAssistant } from '../../contexts/AISalesAssistantContext';
import { useClosingAssistant } from '../../contexts/ClosingAssistantContext';
import { BellIcon, CheckCircleIcon, AlertCircleIcon, XCircleIcon, InfoIcon, MessageSquareIcon, MicIcon } from 'lucide-react';
export const NotificationBadge: React.FC = () => {
  const {
    isOpen,
    isMinimized,
    setIsOpen,
    setIsMinimized,
    setActiveFeature,
    hasImportantInsights
  } = useAISalesAssistant();
  const {
    insights
  } = useClosingAssistant();
  // Get the most recent unread important insight (success or error)
  const importantInsight = insights.filter(insight => !insight.dismissed && (insight.severity === 'success' || insight.severity === 'error')).sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime())[0];
  if (!importantInsight || !isMinimized || !hasImportantInsights) return null;
  const handleClick = () => {
    if (!isOpen) {
      setIsOpen(true);
    }
    setIsMinimized(false);
    setActiveFeature('insights');
  };
  return <div className="fixed top-20 right-4 max-w-xs z-50 animate-slide-in-right cursor-pointer" onClick={handleClick} data-id="element-304">
      <div className={`flex items-center p-3 rounded-lg shadow-lg border ${importantInsight.severity === 'success' ? 'bg-green-50 border-green-200' : importantInsight.severity === 'error' ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200'}`} data-id="element-305">
        <div className="mr-3" data-id="element-306">
          {importantInsight.severity === 'success' && <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-307" />}
          {importantInsight.severity === 'error' && <XCircleIcon className="h-5 w-5 text-red-500" data-id="element-308" />}
          {importantInsight.severity === 'warning' && <AlertCircleIcon className="h-5 w-5 text-yellow-500" data-id="element-309" />}
          {importantInsight.severity === 'info' && <InfoIcon className="h-5 w-5 text-blue-500" data-id="element-310" />}
        </div>
        <div data-id="element-311">
          <p className="text-sm font-medium text-gray-800" data-id="element-312">
            {importantInsight.message}
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-313">Click to view details</p>
        </div>
      </div>
    </div>;
};